import axios from "axios";
import {GET_REPORTS} from "../app/modules/auth/core/_requests";

export function UserReports(selectUsername: any, token: string | null) {
    const id: { selectUsername: string } = selectUsername
    return axios.post(GET_REPORTS, {
        "token": token,
        "owner": null,
        "reciepts_Id": `${id.selectUsername}`,
        "cooperators_Id": null,
        "fromDate": null,
        "toDate": null,
        "isFinished": true,
        "skipCount": null,
        "maxResultCount": null
    })
}
